import { useEffect, useState } from "react";
import { Collapse, Form, Table } from "react-bootstrap";
import {
  FaRegCopy,
  FaCheck,
} from "react-icons/fa"
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
import { fetchIFSCDetails } from "../../APIHelpers/utils";
import AdditionalDetails from "./AdditionalDetails";

const ViewBankAccountDetails = ({ auth, itemData, hideShow, setHideShow, activeItem, plateformSettings }) => {
  const [copiedField, setCopiedField] = useState(null);
  const [bankName, setBankName] = useState("");
  const [bankIcon, setBankIcon] = useState("");
  const [bankColor, setBankColor] = useState("");
  const [bankDetails, setBankDetails] = useState("");

  const getIFSCDetails = async () => {
    const res = await fetchIFSCDetails(randerValue("IFSC_CODE"));
    setBankDetails(res);
  };

  function formatAccountNumber(accountNumber) {
    return accountNumber
      .toString()
      .replace(/\s+/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  }

  function maskAccountNumber(accountNumber) {
    const str = accountNumber.toString();
    const last4 = str.slice(-4);
    const maskedLength = str.length - 4;
    const masked = "X".repeat(maskedLength);
    const grouped = masked.match(/.{1,4}/g)?.join(" ") || "";
    return grouped + " " + last4;
  }

  function maskIFSC(ifsc) {
    if (!ifsc) return "";
    const str = ifsc.toString().toUpperCase();
    return str.slice(0, 7) + "XXXX";
  }

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 1500);
  };

  const renderCopyIcon = (field, value) =>
    copiedField === field ? (
      <FaCheck style={{ marginTop: -4, fontSize: 14 }} />
    ) : (
      <FaRegCopy
        style={{ cursor: "pointer", marginTop: -4, fontSize: 14 }}
        title="Copy"
        onClick={() => handleCopy(value, field)}
      />
    );

  const randerBankData = async (key) => {
    let data = await superAdminMetaServices.getSingleMetadata(auth, "bankaccount", key)
    setBankName(data?.data?.name)
    setBankIcon(data?.data?.icon)
    setBankColor(data?.data?.bgColor)
  };

  const randerValue = (name) => {
    let getData = (itemData?.itemInfo || [])?.find(item => item.name === name)
    return getData?.value
  };


  useEffect(() => {
    let bankData = (itemData?.itemInfo || [])?.find(item => item.name === "BANK")?.value
    if (bankData) {
      randerBankData(bankData);
    }
  }, [itemData]);

  useEffect(() => {
    if (hideShow) {
      getIFSCDetails()
    }
  }, [hideShow]);
  return (
    <>
      <div className="p-4 rounded shadow-sm mt-5 mb-3 position-relative" style={{ backgroundColor: bankColor }}>
        {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowConfidentialsDataOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowConfidentialsDataOption) &&
          <Form.Check
            type="switch"
            className="position-absolute"
            label={hideShow ? "Hide" : "Show"}
            checked={hideShow}
            style={{ fontSize: 13, top: -25, right: 0 }}
            onChange={() => setHideShow(!hideShow)}
          />
        }
        <div
          className="rounded-circle bg-white position-absolute border hstack justify-content-center align-items-center start-50 translate-middle-x"
          style={{ top: -30, width: 50, height: 50 }}
        >
          <img width={25} height={25} src={bankIcon} />
        </div>
        <div className="text-center text-white mt-2">
          <h6>{bankName}</h6>
        </div>
        <div className="d-flex justify-content-between mt-4 flex-end">
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Account Number</h6>
            <h5 style={{ fontSize: 16 }} className="mt-2">
              {hideShow
                ? formatAccountNumber(randerValue("ACCOUNT_NUMBER"))
                : maskAccountNumber(randerValue("ACCOUNT_NUMBER"))
              }
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("accountNumber", randerValue("ACCOUNT_NUMBER"))}
                </>
              }
            </h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">Account Holder Name</h6>
            <h5 style={{ fontSize: 16 }}>
              {randerValue("ACCOUNT_HOLDER_NAME")}
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("accountHolderName", randerValue("ACCOUNT_HOLDER_NAME"))}
                </>
              }
            </h5>
          </div>
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>IFSC</h6>
            <h5 style={{ fontSize: 16 }}>
              {hideShow
                ? randerValue("IFSC_CODE")
                : maskIFSC(randerValue("IFSC_CODE"))
              }
              {!(activeItem === "archived" || activeItem === "trash") && (!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                <>
                  {" "}{renderCopyIcon("ifscCode", randerValue("IFSC_CODE"))}
                </>
              }
            </h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">Account Type</h6>
            <h5 style={{ fontSize: 16 }}>{randerValue("ACCOUNT_TYPE")}</h5>
          </div>
        </div>
      </div>
      <div className="overflow-auto" style={{height: "calc(100vh - 400px)"}}>
        <Collapse in={hideShow}>
          <div className="border rounded pt-2 mb-2" style={{ fontSize: 12 }}>
            <Table hover className="m-0">
              <thead className="position-sticky top-0">
                <tr>
                  <th>Attribute</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {bankDetails?.BANK &&
                  <tr>
                    <td className="item-secondary">BANK</td>
                    <td className="item-secondary">{bankDetails?.BANK}</td>
                  </tr>
                }
                {bankDetails?.IFSC &&
                  <tr>
                    <td className="item-secondary">IFSC</td>
                    <td className="item-secondary">{bankDetails?.IFSC}</td>
                  </tr>
                }
                {bankDetails?.BRANCH &&
                  <tr>
                    <td className="item-secondary">BRANCH</td>
                    <td className="item-secondary">{bankDetails?.BRANCH}</td>
                  </tr>
                }
                {bankDetails?.ADDRESS &&
                  <tr>
                    <td className="item-secondary">ADDRESS</td>
                    <td className="item-secondary">{bankDetails?.ADDRESS}</td>
                  </tr>
                }
                {bankDetails?.CONTACT &&
                  <tr>
                    <td className="item-secondary">CONTACT</td>
                    <td className="item-secondary">{bankDetails?.CONTACT}</td>
                  </tr>
                }
                {bankDetails?.CITY &&
                  <tr>
                    <td className="item-secondary">CITY</td>
                    <td className="item-secondary">{bankDetails?.CITY}</td>
                  </tr>
                }
                {bankDetails?.DISTRICT &&
                  <tr>
                    <td className="item-secondary">DISTRICT</td>
                    <td className="item-secondary">{bankDetails?.DISTRICT}</td>
                  </tr>
                }
                {bankDetails?.STATE &&
                  <tr>
                    <td className="item-secondary">STATE</td>
                    <td className="item-secondary">{bankDetails?.STATE}</td>
                  </tr>
                }
                {bankDetails?.RTGS &&
                  <tr>
                    <td className="item-secondary">RTGS</td>
                    <td className="item-secondary">{bankDetails?.RTGS ? "Yes" : "No"}</td>
                  </tr>
                }
                {bankDetails?.BANKCODE &&
                  <tr>
                    <td className="item-secondary">BANKCODE</td>
                    <td className="item-secondary">{bankDetails?.BANKCODE}</td>
                  </tr>
                }
              </tbody>
            </Table>
          </div>
        </Collapse>
        <AdditionalDetails
          itemData={itemData}
          activeItem={activeItem}
          plateformSettings={plateformSettings}
        />
      </div>
    </>
  );
};

export default ViewBankAccountDetails;
